import { Component, AfterViewInit, OnInit, OnDestroy, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../shared/constants/constants';
import { Utility } from '../../common/utility';
import { BaseUrl } from '../../shared/urls/base.url';
import { BaseService } from '../../shared/services/base.service';
import { DialogService } from '../../shared/services/dialog.service';
import { DataEntryPopupComponent } from './data-entry-popup.component';
import { PermissionService } from '../../shared/services/permission.service';
import { AuthGuard } from '../../auth.guard';
import { DataEntryService } from './data-entry.service';
import { ManageCentreService } from '../../pages/centre/manage-centre/manage-centre.service';
//import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ManageBookingService } from '../../pages/booking/manage-booking/manage-booking.service';
import { SharedService } from '../../shared/services/share.services';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  providers: [DataEntryService, ManageCentreService, ManageBookingService]
})

export class HeaderComponent implements AfterViewInit, OnInit, OnDestroy {
  @Output() menuToggle = new EventEmitter<boolean>();
  @Output() updatePermission = new EventEmitter<any>();
  public tmbLogo = '/assets/images/tmb_new_white.png';
  public nomadLogo = '/assets/images/nomad_logo.png';
  public centreLogo = '';
  public centreName: string;
  public userName: string;
  public dataEntryTitle = ['Data Entry', 'Turn Off Data Entry'];
  public dataEntryMode = 0; // 0: Not in Data Entry Mode, 1: In data entry mode
  public dataEntryWelcome = 'DE.';
  constructor(private activeRoute: ActivatedRoute,
    private authGuard: AuthGuard,
    private router: Router,
    private baseService: BaseService,
    private dialogService: DialogService,
    private dataEntryService: DataEntryService,
    private permissionService: PermissionService,
    private centreService: ManageCentreService,
    private manageBookingService: ManageBookingService,
    private sharedService: SharedService) {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.getCentreLogo();
    this.centreName = localStorage.getItem(AppConstants.localStorage.centreName);
    if (localStorage.getItem(AppConstants.localStorage.deUserName) !== 'null') {
      this.userName = localStorage.getItem(AppConstants.localStorage.deUserName);
      this.dataEntryMode = 1;
    } else {
      this.userName = localStorage.getItem(AppConstants.localStorage.userName);
    }
  }

  ngOnDestroy() {

  }

  onChangePassword() {
    // navigate to change password page
    this.router.navigate(['/change-password']);
  }

  onLogout() {
    // delete booking cache (SD10001680-604)
    this.manageBookingService.deleteBookingCache().subscribe(
      (result) => {
        this.baseService.logout();
      }
    );
  }

  toggleMenu() {
    this.menuToggle.emit(true);
  }

  onChangeCentre() {
    // navigate to select centre page
    this.router.navigate(['/select-centre']);
  }

  onWaitingRoom()
  {
    // navigate to Waiting room page
    this.router.navigate(['/consultation/waiting-room'])
  }

  /**
   * toggle data entry mode
   */
  onChangeDataEntry() {
    // turn on data entry mode
    if (this.dataEntryMode === 0) {
      // open data entry mode dialog
      this.dialogService.openComponentDialog(DataEntryPopupComponent).subscribe(
        (result) => {
          if (result) {
            const param = {
              userId: result['userId'],
              isDataEntryMode: true
            };
            this.dataEntryService.toggleImpersonatedUserPermission(param).subscribe(
              resultDataEntry => {
                if (resultDataEntry) {
                  const data = resultDataEntry.json();
                  this.updateDataEntryPermission(1, data['permissions'], result);
                }
              });
          }
        });
    } else {
      // turn off data entry mode
      const param = {
        userId: null,
        isDataEntryMode: false
      };
      this.dataEntryService.toggleImpersonatedUserPermission(param).subscribe(
        resultDataEntry => {
          if (resultDataEntry) {
            const data = resultDataEntry.json();
            this.updateDataEntryPermission(0, data['permissions']);
          }
        });
    }
  }

  updateDataEntryPermission(dataEntryMode, permission, impersonatedData = null) {
    this.dataEntryMode = dataEntryMode;
    // save user permission on pages
    localStorage.setItem(AppConstants.localStorage.permissionOnPage, permission);
    this.permissionService.setPermissionOnPage(permission);
    this.updatePermission.emit(true);

    if (dataEntryMode === 1 && impersonatedData) {
      this.userName = this.dataEntryWelcome + impersonatedData['firstName'] + ' ' + impersonatedData['sureName'];
      this.baseService.setDataEntry(this.userName, impersonatedData['userId']);
    } else {
      this.userName = localStorage.getItem(AppConstants.localStorage.userName);
      this.baseService.setDataEntry(null, null);
      // check if off data entry then this user still has permission on current page or not
      if (!this.permissionService.hasPermissionWithoutParam(this.router.routerState.snapshot.url)){
        this.router.navigate(['/consultation/waiting-room']);
      }
    }
    this.sharedService.announceDataEntryUpdate(dataEntryMode);
  }

  /**
   * function to update user name when user info is changed
   * @param data
   */
  updateUserInfo(data) {
    if (data && data.hasOwnProperty('firstName') && data.hasOwnProperty('lastName')) {
      this.userName = data['firstName'] + ' ' + data['lastName'];
      // set user name to localstorage
      localStorage.setItem(AppConstants.localStorage.userName, data['firstName'] + ' ' + data['lastName']);
    }
  }

  /**
  * function to update centre name and logo when centre info is changed
  * @param data: centreName
  */
  updateCentreInfo(data) {
    this.centreName = data;
    this.getCentreLogo();
  }

  getCentreLogo() {
    this.centreService.getCentreLogo(localStorage.getItem(AppConstants.localStorage.centreId)).subscribe(
      result => {
        const data = result.json();
        this.centreLogo = data['centreLogo'];
      }
    );
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/header/header.component.ts